import './scss/styles.scss';
import { gsap, ScrollTrigger } from 'gsap/all';
import Swiper, { Navigation, Pagination } from 'swiper';
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
jQueryBridget('isotope', Isotope, jQuery);

gsap.registerPlugin(ScrollTrigger);

// Slider
const myCustomSlider = document.querySelectorAll('.swiper');
for (let i = 0; i < myCustomSlider.length; i++) {

    myCustomSlider[i].classList.add('swiper-' + i);

    const slider = new Swiper('.swiper-' + i, {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        loop: true,

        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

}

const myCustomCarousel4 = document.querySelectorAll('.carousel-4');
for (let i = 0; i < myCustomCarousel4.length; i++) {

    myCustomCarousel4[i].classList.add('carousel-4-' + i);

    const items = myCustomCarousel4[i].querySelectorAll('.swiper-slide');

    if (items.length > 3) {
        myCustomCarousel4[i].classList.add('swiper-all-items');
    }

    const carousel = new Swiper('.carousel-4-' + i, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.3,
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 2.5,
            },
            1280: {
                slidesPerView: 3.5,
            },
            1366: {
                slidesPerView: 4,
            },
        }
    });
}

const myCustomCarousel3 = document.querySelectorAll('.carousel-3');
for (let i = 0; i < myCustomCarousel3.length; i++) {

    myCustomCarousel3[i].classList.add('carousel-3-' + i);

    const items = myCustomCarousel3[i].querySelectorAll('.swiper-slide');

    const carousel3 = new Swiper('.carousel-3-' + i, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.3,
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 2.5,
            },
            1280: {
                slidesPerView: 3,
            }
        }
    });
}


// IntersectionObserver
const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('inview');
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

function observerInit() {
    const sections = Array.from(document.querySelectorAll('.animated'));

    for (let section of sections) {
        observer.observe(section);
    }

    const sectionsStagger = Array.from(document.querySelectorAll('.animated-stagger'));
    for (let sectionStagger of sectionsStagger) {

        const item = sectionStagger.children;

        for (let i = 0; i < item.length; i++) {
            item[i].style.transitionDelay = + i * 0.25 + 's';
        }
        observer.observe(sectionStagger);
    }
}

window.addEventListener('DOMContentLoaded', (event) => {
    const h = document.querySelector('body');
    const i = document.querySelector('#app-intro');

    if (h.classList.contains('home')) {
        i.classList.add('is-load');
        i.addEventListener("transitionend", function () {
            setTimeout(() => {
                observerInit();
            }, 1000)

        });
    } else {
        observerInit();
    }
});



jQuery(document).ready(function ($) {

    // Sticky Header
    $(window).scroll(function () {
        var header = $('#app-header');
        var hero = $('.view-hero');
        var scrollPosition = $(window).scrollTop();

        if (scrollPosition >= 100) {
            header.addClass('is-sticky');
        } else {
            header.removeClass('is-sticky');
        }

        if (scrollPosition >= 1) {
            hero.addClass('is-sticky');
        }
        else {
            hero.removeClass('is-sticky');
        }
    });

    ScrollTrigger.create({
        //markers: { startColor: "green", endColor: "red", fontSize: "10px", fontWeight: "normal", indent: 0 },
        //id: 'pin1',
        pin: true,
        trigger: ".view-hero",
        start: "top top",
        end: '+=300',
    })



    // Menu
    $('.burger').click(function (event) {
        event.preventDefault();
        $("body").toggleClass('open-menu');
    });

    if ($(window).width() < 1025) {
        $('#primary-menu .menu-item-has-children > a').click(function (event) {
            $(".sub-menu").not($(this).next()).slideUp();
            $(this).toggleClass("is-open");
            $(this).next().slideToggle();
        });
    }
    else if ($(window).width() > 1024) {
        $('#primary-menu .menu-item-has-children').mouseenter(function () {
            $(this).find('.sub-menu').stop().slideDown('slow');
        }).mouseleave(function () {
            $(this).find('.sub-menu').stop().slideUp('slow');
        });
    }
    $('#primary-menu .menu-item-has-children > a').click(function (event) {
        event.preventDefault();
    });




    // Cursor programme hover -  css var x/y
    var cursorOverlay = $(".view-programs .back");
    $(cursorOverlay).mousemove(function (event) {
        var { x, y } = event.target.getBoundingClientRect();
        $(this).css("--x", event.clientX - x);
        $(this).css("--y", event.clientY - y);
    });



    // Isotope
    var initial_items = 6;
    var next_items = 6;
    var $grid = $('.masonry').isotope({
        itemSelector: '.masonry-item',
        layoutMode: 'fitRows',
    });


    $('.filter-posts').on('click', '.btn', function (event) {
        event.preventDefault();
        var filterValue = $(this).attr('data-filter');
        $grid.isotope({ filter: filterValue });
        updateFilterCounts();
    });
    function updateFilterCounts() {
        var itemElems = $grid.isotope('getFilteredItemElements');
        var count_items = $(itemElems).length;

        if (count_items > initial_items) {
            $('#btn-load-more').show();
        }
        else {
            $('#btn-load-more').hide();
        }
        if ($('.masonry-item').hasClass('visible_item')) {
            $('.masonry-item').removeClass('visible_item');
        }
        var index = 0;

        $(itemElems).each(function () {
            if (index >= initial_items) {
                $(this).addClass('visible_item');
            }
            index++;
        });
        $grid.isotope('layout');
    }

    $('.filter-posts').each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', '.btn', function () {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');
        });
    });

    function showNextItems(pagination) {
        var itemsMax = $('.visible_item').length;
        var itemsCount = 0;
        $('.visible_item').each(function () {
            if (itemsCount < pagination) {
                $(this).removeClass('visible_item');
                itemsCount++;
            }
        });
        if (itemsCount >= itemsMax) {
            $('#btn-load-more').hide();
        }
        $grid.isotope('layout');
    }
    function hideItems(pagination) {


        var itemsMax = $('.masonry-item').length;
        var itemsCount = 0;

        $('.masonry-item').each(function () {
            if (itemsCount >= pagination) {
                $(this).addClass('visible_item');
            }
            itemsCount++;
        });
        if (itemsCount < itemsMax || initial_items >= itemsMax) {
            $('#btn-load-more').hide();
        }
        $grid.isotope('layout');
    }
    $('#btn-load-more').on('click', function (event) {
        event.preventDefault();
        showNextItems(next_items);
    });

    hideItems(initial_items);




    // Contact
    setTimeout(function () {
        var hash = window.location.hash.substr(1);

        if (hash) {
            $("#nf-field-7").val(hash)
            if (hash === 'coaching-personnalise') {
                $('#nf-field-8-wrap').show();
            }
        }

        $('#nf-field-7').on('change', function () {
            if ($(this).val() === 'coaching-personnalise') {
                $('#nf-field-8-wrap').show();
            } else {
                $('#nf-field-8-wrap').hide();
            }
        });
    }, 1000);


    // video
    var play = false;
    $("#play-video").click(function (event) {
        event.preventDefault()
        if (play == false) {
            play = true;
            $(this).addClass("is-play").removeClass("is-pause")
            $("#player").get(0).play();

        }
        else {
            $(this).addClass("is-pause").removeClass("is-play");
            $("#player").get(0).pause();
            play = false;
        }
    });


    // Image expand container
    var debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    function checkMedia() {

        var t = $('.full-image .col-lg-4');
        var c = $('.full-image .media>div');
        var l = t.offset().left;

        $(".view-content-img-text .row").each(function (index) {
            if ($(this).hasClass('reverse-bloc')) {
                $(this).find(c).css({
                    marginRight: -l - 15 + "px"
                })
            }
            else {
                $(this).find(c).css({
                    marginLeft: -l - 15 + "px"
                })
            }
        });
    }


    if ($('.full-image').length > 0) {
        checkMedia();
        $(window).resize(debounce(function () {
            checkMedia();
        }, 600));
    }


    // Detect
    var isAndroid = / Android/i.test(navigator.userAgent.toLowerCase());
    if (isAndroid) {
        $('body').addClass('a-sys');
    }
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $('body').addClass('m-sys');
    } else {
        $('body').addClass('w-sys');
    }
});

console.info("%cMade with ❤︎ by Buzznative / Lola Bridier / Teddy Bugra.", "background:#000;color:#FFF;padding:0.2em 1.5em;line-height:2;font-size:8px");